import React, { useState } from 'react';
import { Player } from '../types';
import { isPedagogicalStaff } from '../utils/roles';

interface AvatarProps {
  player: Player;
  isMe: boolean;
  onClick?: () => void;
}

const Avatar: React.FC<AvatarProps> = ({ player, isMe, onClick }) => {
  const [hasError, setHasError] = useState(false);
  const displayName = player.wizardName || player.name || 'Ukendt';
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div className="flex flex-col items-center transition-all duration-300 pointer-events-none">
      <div
        className={`flex flex-col items-center ${onClick ? 'cursor-pointer pointer-events-auto hover:scale-110' : ''} transition-all duration-300`}
        onClick={onClick}
      >
        <div className="relative">
          {isMe && (
            <div className="absolute -top-7 left-1/2 -translate-x-1/2 text-[9px] md:text-[10px] bg-yellow-400 text-black px-2 py-0.5 rounded-md font-black uppercase tracking-[0.2em] shadow-lg z-20 border border-black/10">
              DIG
            </div>
          )}
          <div className={`w-10 h-10 md:w-16 md:h-16 rounded-full border-2 ${isMe ? 'border-yellow-400 shadow-[0_0_20px_rgba(234,179,8,0.5)]' : 'border-purple-500 shadow-xl'} overflow-hidden bg-indigo-950 flex items-center justify-center transition-all duration-500 group relative`}>
            {player.avatarUrl && !hasError ? (
              <img
                src={player.avatarUrl}
                alt={displayName}
                className="w-full h-full object-cover transition-transform group-hover:scale-110"
                onError={() => setHasError(true)}
                referrerPolicy="no-referrer"
              />
            ) : (
              <div className={`w-full h-full flex items-center justify-center font-cinzel font-bold text-base md:text-xl ${isMe ? 'text-yellow-500' : 'text-purple-400'} bg-gradient-to-br from-indigo-900 to-black`}>
                {initial}
              </div>
            )}
            <div className="absolute inset-0 bg-yellow-400/0 group-hover:bg-yellow-400/10 transition-colors" />
          </div>
        </div>
        <div className="mt-1 md:mt-2 flex flex-col items-center min-w-[100px] md:min-w-[150px]">
          <div className={`px-2 md:px-4 py-1 md:py-1.5 rounded-lg md:rounded-xl text-[8px] md:text-[10px] font-bold text-white shadow-2xl backdrop-blur-md border border-white/10 whitespace-nowrap w-fit text-center ${isMe ? 'bg-yellow-900/90 border-yellow-500/40' : 'bg-indigo-900/90 border-indigo-400/40'}`}>
            {displayName}
          </div>
          {isPedagogicalStaff(player.role) && (
            <div className="bg-black/80 px-1.5 py-0.5 rounded-full mt-0.5 border border-yellow-500/20">
              <span className="text-[6px] md:text-[7px] text-yellow-500 font-black uppercase tracking-[0.15em] drop-shadow-md">
                {player.role === 'admin' ? 'Mester-Vogter' : 'Vogter'}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Avatar;